module.exports = __webpack_public_path__ + "static/media/signup-user.bba2ce3b.png";